import { render, staticRenderFns } from "./ProminentWScrollShrinkAndImage.vue?vue&type=template&id=d11e6a08&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports